import BookItem from "../common/bookItem";
export default class AfilePageCount extends BookItem {
    constructor(el, target) {
        super(el, target);

        //測試用

    }
    //沒用了
    init() {
        console.log(this.target.parent);
        console.log(this.target.pageNum);
        this.trigger();
    }

    trigger() {
        this.target.pageNum.text = (this.target.parent.currentFrame + 1) + "/" + this.target.parent.totalFrames;
    }
}